<template>
  <Modal :open="internalOpen" :width=800 @update:open="handleClose">
    <template #header>
      <ModalHeader variant="cross" @cancel="handleClose">
        <h1>{{ $t('toolbar.export.warning.title') }}</h1>
      </ModalHeader>
    </template>

    <div>
      <p v-if="isVerifications" class="pb-4">
        {{ $t('toolbar.export.warning.messageVerifications', { count: photoCount, total: photoCount * 5 }) }}
      </p>
      <p v-else class="pb-4">
        {{ $t('toolbar.export.warning.message', { count: photoCount }) }}
      </p>
      <div class="flex justify-end space-x-4 pt-4">
        <button @click="handleClose" class="px-4 py-2">
          {{ $t('toolbar.export.warning.cancel') }}
        </button>
        <button @click="confirmDownload" class="px-4 py-2 btn bg-primary border-primary rounded-4 text-white">
          {{ $t('toolbar.export.warning.confirm') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';

interface Props {
  open: boolean;
  photoCount: number;
  isVerifications: boolean;
}

const emit = defineEmits(['update:open', 'cancel', 'confirm']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);
const { t } = useI18n();


const handleClose = () => {
  internalOpen.value = false;
  emit('cancel'); 
};

const confirmDownload = () => {
  internalOpen.value = false;
  emit('confirm');
};

</script>

